import { NavLink } from 'react-router-dom'
import React from 'react'
import { MonitorOutlined } from '@ant-design/icons'
import { routersPath } from '@router/routes-path'

export interface ITabs {
  title: JSX.Element | Element
  pages: routersPath[]
}

export const bossTabs: ITabs[] = [
  {
    title: (
      <NavLink to={routersPath.SEARCH}>
        <MonitorOutlined />
        Поиск
      </NavLink>
    ),
    pages: [routersPath.SEARCH, routersPath.SEARCH_USER],
  },
]
